const defaultState = {
	fullName: '',
	needFirstReport: false,
	userId: null
}

function reducer(state = defaultState, action) {
	const { payload } = action
	switch (action.type) {
		case 'SET_PATIENT_INFO':
			return {
				...state,
				...payload
			}
		case 'RESET_PATIENT_INFO':
			return { ...defaultState }
		case 'UPDATE_PATHOLOGY_PATIENT':
			return { ...state, pathologies: payload.pathologies }
		case 'UPDATE_PLAN_PATIENT':
			return { ...state, vitalPlanActivated: payload.vitalPlanActivated }
		default:
			return state
	}
}

export default reducer
